import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AnimalSearchFilters } from '../../modules/animals/states/animal.repository';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  searchTermSubject = new BehaviorSubject<string>('');
  searchTerm$ = this.searchTermSubject.asObservable();

  searchFiltersSubject = new BehaviorSubject<AnimalSearchFilters>({} as AnimalSearchFilters);
  searchFilters$ = this.searchFiltersSubject.asObservable();

  showFiltersSubject = new BehaviorSubject<boolean>(false);
  showFilters$ = this.showFiltersSubject.asObservable();

  paginationSubject = new BehaviorSubject<{ first: number | null; page: number; rows: number }>({ first: null, page: 0, rows: 6 });
  pagination$ = this.paginationSubject.asObservable();
}
